var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFriendly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M45.011 19.938c-.1 0-5.7-5.5-7.4-7.4-.6-.6-1.3-1-2-1h-2.2c-.2 0-.4.2-.5.4-.1.5-.6.9-1.2.9s-1.2-.4-1.2-.9c0-.2-.2-.4-.5-.4h-2.2c-.9 0-1.6.5-2 .9l-6.7 6.7-7.6-4c-.9-2-3-3.3-4.8-3.1l-.7.1c-2.2.2-3.8 2.3-3.7 5 .1 2.9 1.1 11.7 1.1 11.7 0 .2.2.4.5.4h.6l-4.2 11.6c-.6 1.6.3 3.3 1.8 3.9.3.1.7.2 1 .2 1.3 0 2.4-.8 2.8-2l1.2-3.3.4 3c.2 1.5 1.5 2.6 3 2.6h.4c.8-.1 1.5-.5 2-1.2.5-.6.7-1.4.6-2.2l-1.9-13.2 1.2-.1c.1 0 .2-.1.3-.2.1-.1.1-.2.1-.3l-.9-6.5 4.4 2.2c.7.3 1.5.4 2.1.1.2.1.5.1.8.1.6 0 1.2-.2 1.6-.7l3.7-3.7v6.6c0 .3.2.5.5.5h.2v15.3c0 1.6 1.3 2.9 2.9 2.9 1.6 0 2.9-1.3 2.9-2.9v-10.3h.1v10.2c0 1.6 1.3 2.9 2.9 2.9 1.6 0 2.9-1.3 2.9-2.9v-15.3h.2c.2 0 .5-.2.5-.5v-6.5l3.6 3.6c.4.4 1 .7 1.6.7.6 0 1.2-.2 1.6-.7.4-.4.7-1 .7-1.6.1-.6-.1-1.2-.5-1.6Zm-39.7 22.6c-.3.9-1.1 1.4-2 1.4-.2 0-.5 0-.7-.1-.5-.2-1-.6-1.2-1.1-.2-.5-.3-1.1-.1-1.6l.3-.9 3.9 1.5-.2.8Zm1.2-3.4-.6-.2c-.2-.1-.5 0-.6.3-.1.2 0 .5.3.6l.6.2-.3.9-3.9-1.5 3.7-10.3.7-.1-1.6 4.4v.4c.1.1.1.2.3.2h.2c.2 0 .4-.1.4-.3l1.7-4.8 3-.3-3.9 10.5Zm6.4 2.7c.2 1.2-.7 2.2-1.8 2.4-.5.1-1.1-.1-1.5-.4-.5-.3-.7-.8-.8-1.4l-.1-.8 4.2-.7v.9Zm-.5-3.6-.6.1c-.1 0-.2.1-.3.2-.1.1-.1.2-.1.3 0 .2.2.4.5.4l.6-.1.1.9-4.2.7-.4-2.9 3.1-8.5 1.3 8.9Zm-8.1-10c-.2-1.6-.9-8.7-1-11.2-.1-2.2 1.1-3.9 2.8-4.1l.7-.1h.3c1 0 2.1.5 2.9 1.4l-1.4-.7c-.3-.2-.8-.3-1.2-.3-.9 0-1.8.5-2.2 1.4-.6 1.2-.2 2.8 1.1 3.4l5.4 2.8.4 3-1.1.1c-.2 0-.4.2-.4.5 0 .2.2.4.5.4l1.2-.1.1.8-4.9.5c-.1 0-.2.1-.3.2-.1.1-.1.2-.1.3 0 .2.2.4.5.4l5-.5.1 1-8.4.8Zm15.3-6.1c-.3.5-.8.9-1.4.9-.3 0-.5-.1-.7-.2l-10.7-5.5c-.4-.2-.7-.5-.8-.9-.1-.4-.1-.8.1-1.2.3-.5.8-.9 1.4-.9.3 0 .5.1.7.2l10.7 5.5c.4.2.7.5.8.9.1.4.1.8-.1 1.2Zm1.2.4c-.2.2-.4.3-.6.3.1-.1.1-.2.2-.3.3-.6.4-1.3.2-1.9-.1-.4-.3-.7-.6-1l2.9-2.9 1.9 1.9-4 3.9Zm4.4-4.7-1.7-1.7 1.7-1.7v3.4Zm9.4 25.9c-1.1 0-2-.9-2-2v-10.6c0-.3-.2-.5-.5-.5h-1c-.2 0-.5.2-.5.5v10.6c0 1.1-.9 2-2 2s-2-.9-2-2h2.7c.3 0 .5-.2.5-.5s-.2-.5-.5-.5h-2.7v-11.3l1.9-1.9c.2-.2.2-.5 0-.7-.2-.2-.5-.2-.7 0l-1.2 1.2v-1.6h9.9v1.6l-1.2-1.2c-.2-.2-.5-.2-.7 0-.1.1-.1.2-.1.3 0 .1 0 .2.1.3l1.9 1.9v10h-.6c-.2 0-.5.2-.5.5s.2.5.5.5h.6v.5h-2.7c-.3 0-.5.2-.5.5 0 .2.2.5.5.5h2.7c.1 1.1-.8 1.9-1.9 1.9Zm2.6-18.1h-11.1v-1.8h4.7c.2 0 .5-.2.5-.5 0-.2-.2-.5-.5-.5h-4.7v-8.7c0-.9.8-1.7 1.7-1.7h1.8c.3.8 1.1 1.3 2.1 1.3.9 0 1.8-.5 2-1.3h1.8c1 0 1.7.8 1.7 1.7v11.5Zm1-11.2 1.6 1.6-1.6 1.6v-3.2Zm6.1 8c-.5.5-1.4.5-1.9 0l-3.9-3.9 1.9-1.9 3.9 3.9c.2.2.4.6.4.9 0 .4-.1.8-.4 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M35.81 15.237h-2.6c-.3 0-.5.2-.5.5v1.7c0 .2.1.3.2.4l1.3.9c.1 0 .2.1.3.1.1 0 .2 0 .3-.1l1.3-.9c.1-.1.2-.2.2-.4v-1.7c0-.2-.2-.5-.5-.5Zm-1.3 2.6-.8-.6v-1h1.7v1l-.9.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M36.31 14.837c0 .2-.2.5-.5.5h-1.9c-.2 0-.5-.2-.5-.5s.2-.5.5-.5h1.9c.3 0 .5.2.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M11.31 4.438c-.5-1.2-1.3-2-2.5-2.5v-.7c-.2-.7-1.1-1-1.8-1.1-.4-.1-.7-.1-1.1-.1-1.4 0-2.8.5-3.9 1.6-.9.8-1.9 2.3-2 4-.1 1.4.5 2.7 1.6 3.9 1.5 1.7 3.3 1.8 3.6 1.8.4.1.8.2 1.2.2.7 0 1.4-.2 2.2-.5 1.2-.5 2.2-1.5 2.7-2.8.6-1.2.5-2.5 0-3.8Zm-1.1 3.1c-.1 0-.2.1-.2.3v.3c.1.2.2.2.3.3-.4.8-1.1 1.5-2 1.8-.9.4-1.7.5-2.4.4 0-.8-.8-1.7-1-1.9-.1-.1-.2-.1-.4-.1-.3 0-.6-.1-.7-.4-.1-.2-.1-.4 0-.5.1-.2.2-.3.4-.4.4-.1.8 0 .9.4l.7 1.6c0 .1.1.2.2.2h.4l1-.5c.2-.1.3-.3.3-.6 0-.1-.1-.3-.3-.5-.7-1.2-1.3-2.5 0-3.8.5-.5.8-.9 1.1-1.3.9.4 1.6 1.1 2 2.1l.3.9-.9.4c-.4.2-.8.5-.9 1-.1.5-.2.9 0 1.3l.2.5c.1.2.2.3.4.3h.2c.1 0 .2-.1.2-.2v-.4l-.2-.5c-.1-.2-.1-.4 0-.6.1-.2.2-.4.4-.5l.6-.3c0 .2 0 .4-.1.6l-.5.1Zm-7.8 1.4c-.9-1-1.3-2-1.3-3.1v-.1c.1-1.5.9-2.7 1.7-3.4 1-.9 2.1-1.3 3.3-1.3.3 0 .6 0 .9.1.6.1 1 .3 1 .5 0 .1.1.6-1.2 1.9-1.9 1.9-.7 4-.1 4.9l-.2.1-.5-1.2c-.3-.6-.8-1-1.5-1-.2 0-.4 0-.6.1-.8.4-1.2 1.3-.9 2.1.2.6.8.9 1.4 1 .2.3.5.6.6 1-.6-.2-1.7-.6-2.6-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M37.412 4.537c-.4-1.7-1.6-3-2.7-3.6-1.6-1-3.4-1.2-5.2-.6-.6.2-1.4.6-1.5 1.4 0 .2 0 .4.1.6-1 .7-1.7 1.7-2 2.9-.3 1.3-.1 2.7.6 3.8.7 1.2 1.8 2 3.1 2.3.5.1.9.2 1.4.2.7 0 1.4-.2 1.9-.4.3-.1 2-.6 3.3-2.5 1-1.4 1.3-2.7 1-4.1Zm-4.9 5.8c-.7.3-1.5.3-2.4.1-.9-.2-1.7-.7-2.3-1.5l.3-.3c0-.2-.1-.5-.4-.5l-.5-.1c-.1-.2-.1-.4-.2-.6l.6.2c.2 0 .4.2.5.4.1.2.2.4.1.6l-.1.5c0 .1 0 .2.1.3.1.1.2.2.3.2.2.1.5-.1.6-.3l.1-.5c.1-.5 0-.9-.2-1.3s-.6-.7-1.1-.8l-1-.2c0-.3 0-.6.1-.9.2-1 .8-1.8 1.6-2.4.3.3.7.7 1.3 1.1 1.5 1.1 1.1 2.5.7 3.8-.1.2-.1.4-.2.5 0 .2.1.5.3.5l1.1.3c.1 0 .2 0 .3-.1.1-.1.2-.2.2-.3l.4-1.7c.1-.4.5-.6.8-.5.4.1.6.5.5.9-.1.3-.3.5-.6.5-.1 0-.3.1-.4.2 0 .2-.6 1.1-.5 1.9Zm1.4-1.4c.6-.1 1.1-.6 1.2-1.2.2-.9-.3-1.8-1.2-2h-.4c-.8 0-1.4.5-1.6 1.3l-.3 1.2h-.2c.4-1 1.2-3.2-1-4.8-1.3-1-1.5-1.4-1.5-1.6 0-.2.4-.4.9-.6 1.5-.5 3-.4 4.4.5.9.5 1.9 1.6 2.2 3 .2 1.1 0 2.3-.7 3.4-.8 1.2-1.7 1.7-2.3 1.9.1-.3.3-.8.5-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M5.51 22.238c0 .1 0 .2-.1.3-.1.1-.2.2-.3.2-.2 0-.4-.2-.5-.4l-.4-3.7c0-.3.2-.5.4-.5s.4.2.5.4l.4 3.7Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 22.83,
    x2: 22.83,
    y1: 11.538,
    y2: 45.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 34.511,
    x2: 34.511,
    y1: 15.237,
    y2: 18.837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 34.86,
    x2: 34.86,
    y1: 14.337,
    y2: 15.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 5.862,
    x2: 5.862,
    y1: 0.038,
    y2: 11.538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 31.75,
    x2: 31.75,
    y1: 0,
    y2: 11.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 4.861,
    x2: 4.861,
    y1: 18.138,
    y2: 22.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h46v46H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendly);
export default __webpack_public_path__ + "static/media/friendly.c3da4369677e926a1719ea6191c45210.svg";
export { ForwardRef as ReactComponent };